import React from 'react';

import './HomeAbout.scss';

import homeAbout_1 from '../../../assets/img/llc/homeAbout_4.png';
import homeAbout_2 from '../../../assets/img/llc/homeAbout_5.png';
import homeAbout_3 from '../../../assets/img/llc/homeAbout_uroven.jpg';

class HomeAbout extends React.PureComponent {
  render() {

    return (
      <section className="homeAbout bc-beige2">
        <div className="container">
          <h2 className="line text-center">O klinice LLC</h2>
          <h5 className="text-center">
            Klinika LLC je první nestátní zdravotnické zařízení na severní Moravě, zabývající <br/>
            se léčbou spojenou s využíváním laserové technologie.
          </h5>

          <div className="row homeAbout_item_row">
            <div className="col-4 homeAbout_item_col">
              <div className="homeAbout_item">
                <img src={homeAbout_1} className="homeAbout_item_img" alt={this.props.langs.imgAlt.imgAlt}/>
                <div className="homeAbout_item_content">
                  <div className="homeAbout_item_title">Špičkové vybavení</div>
                  <div className="homeAbout_item_text">
                    Mezi ostatními obdobnými centry má KLINIKA LLC naprostou prioritu jednak ve vybavení
                    laserovými přístroji a také komplexností služeb, které napomáhají klientům udržet si
                    jejich zdraví a krásu.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4 homeAbout_item_col">
              <div className="homeAbout_item">
                <img src={homeAbout_2} className="homeAbout_item_img" alt={this.props.langs.imgAlt.imgAlt}/>
                <div className="homeAbout_item_content">
                  <div className="homeAbout_item_title">Centrum excelence</div>
                  <div className="homeAbout_item_text">
                    Jako první na severní Moravě obdržela právě KLINIKA LLC akreditaci ČLS pro laserovou chirurgii
                    a zároveň je držitelem označení "Centre of excelence" od americké organizace pro využívání
                    laserů v medicíně.
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4 homeAbout_item_col">
              <div className="homeAbout_item">
                <img src={homeAbout_3} className="homeAbout_item_img" alt={this.props.langs.imgAlt.imgAlt}/>
                <div className="homeAbout_item_content">
                  <div className="homeAbout_item_title">Vysoká odborná úroveň</div>
                  <div className="homeAbout_item_text">
                    Celý tým lékařů KLINIKY LLC je na vysoké odborné úrovni. Lékaři se účastní mnoha vědeckých
                    konferencí v ČR i v zahraničí.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default HomeAbout;



// WEBPACK FOOTER //
// ./src/components/HomePage/HomeAbout/HomeAbout.js